<template>
  <div class="haplotype">
    <Search :title="name" :total="haploid">
      <van-tabs v-model="activeTab">
        <van-tab title="迁徙路线">
          <img style="width: 100%;" :src="migration_image" alt="迁徙图">
          <div class="detail">
            <span class="dot"></span><span class="haplotypetitle">单倍型介绍</span>
            <p>{{intro}}</p>
          </div>
          <div class="detail">
            <span class="dot"></span><span class="haplotypetitle">起源时间</span>
            <p>{{origin_time}}</p>
          </div>
          <div class="detail">
            <span class="dot"></span><span class="haplotypetitle">主要分布</span>
            <p>{{distribution}}</p>
          </div>
          <div class="detail">
            <span class="dot"></span><span class="haplotypetitle">代表人群</span>
            <p>{{throng}}</p>
          </div>
        </van-tab>

        <van-tab title="小贴士">
          <div class="tips" v-if="parent === 'father'">
            <p>
              Y染色体是人的性染色体之一，通常只有男性才有Y染色体，在父子间传递，呈严格的父系遗传。科学研究发现，Y染色体有95%的区域为非重组区，即该区段内的遗传信息，一般不随每代的遗传发生变化；然而DNA在通过复制传递遗传信息时，仍会有低概率的错误发生，即突变。在逐代的传递中，这些突变形成了族群的特异性多态标记，称为Y单倍群。因此，Y染色体单倍群分析成为研究人类父系起源、进化和迁徙的有力工具。
            </p>
            <p>
              研究发现，现代世界上所有人类的父系祖先都可以追溯到二十多万年前的一位非洲男性，这个男人被称为“Y染色体亚当”；而非洲以外的居民，则是“亚当”后人走出非洲的后裔。
            </p>
            <p>
              人类Y染色体谱系树是根据Y染色体单倍型类群差异把现代人类分为不同的类型，用从A到T的字母作为索引，使用小写字母和数字进一步细分。Y染色体树的根节点，就是“Y染色体亚当”，代表了我们所有人共同的父系祖先。
            </p>
            <ul>
              <li>现代人类通过Y染色体追溯可分为：</li>
              <li>黄种基因：N、O</li>
              <li>棕种基因：C、D</li>
              <li>白种基因：F、G、H、I、J、K、L、M、R1a、R1b</li>
              <li>黑人基因：A、RxR1、B、ExE3b</li>
              <li>科普特-柏柏尔基因：E3b</li>
              <li>印第安基因：Q</li>
            </ul>
            <img class="treeImg" src="../../assets/images/source/father.png" alt="人类Y染色体谱系树">
            <span class="treeTitle">人类Y染色体谱系树</span>
          </div>
          <div class="tips" v-if="parent === 'mother'">
            <p>
              人类生殖的过程中，精子与卵子结合形成受精卵，受精卵中用以供能的线粒体（MT）由卵子提供。线粒体DNA通常只能随着母亲的卵细胞传递给后代，不会发生同源重组，是严格母系遗传。线粒体DNA在通过复制传递遗传信息时，会有低概率的错误而产生突变。这些突变在人类族群演化过程中被积累，形成了族群的特异性标记，因此研究线粒体单倍群成为了推演人群母系进化的理想方法。
            </p>
            <p>
              研究发现，现代世界上所有人类的母系祖先都可以追溯到约二十万年前非洲的一位女性，这位女性被称为“线粒体夏娃”，“夏娃”的后代中有的继续留在非洲，有的则走出非洲繁衍后代。
            </p>
            <p>
              根据不同族群的MT数据，研究者建立了MT单倍群图谱，每个节点都对应了一个单倍群，代表有相似突变的线粒体。线粒体DNA单倍群用字母A、B、C、CZ、D、E、F、G、H、pre-HV、HV、I、J、pre-JT、JT、K、L0、L1、L2、L3、L4、L5、L6、M、N、O、P、Q、R、S、T、U、UK、V、W、X、Y和Z来标记。MT单倍群树的根节点，代表了我们所有人类共同的母系祖先，即“线粒体夏娃”。
            </p>
            <ul>
              <li>常见的线粒体DNA单倍群支系分布：</li>
              <li>非洲人：L0、L1、L2、L3、L4、L5、L6</li>
              <li>西部欧亚人：H、T、U、V、X、K、I、J、W</li>
              <li>东部欧亚人：A、B、C、D、E、F、G、Y、Z</li>
              <li>美洲原住民：A、B、C、D、X</li>
              <li>澳大拉西亚人：P、Q、S</li>
            </ul>
            <img class="treeImg" src="../../assets/images/source/mother.png" alt="人类线粒体单倍群树">
            <span class="treeTitle">人类线粒体单倍群树</span>
          </div>
        </van-tab>
      </van-tabs>
    </Search>
  </div>
</template>

<script>
import Search from '@/components/Search'
export default {
  name: 'haplotype',
  data () {
    return {
      parent: this.$route.params.parent,
      activeTab: 0,
      name: '父系单倍型',
      haploid: '',
      migration_image: '',
      intro: '',
      origin_time: '',
      distribution: '',
      throng: ''
    }
  },
  methods: {
    paternal_haploid () {
      this.util.get(this.api.paternal_haploid, '', (success) => {
        this.migration_image = success.migration_image
        this.intro = success.intro
        this.origin_time = success.origin_time
        this.distribution = success.distribution
        this.throng = success.throng
        this.haploid = success.haploid
      })
    },
    maternal_haploid () {
      this.util.get(this.api.maternal_haploid, '', (success) => {
        this.migration_image = success.migration_image
        this.intro = success.intro
        this.origin_time = success.origin_time
        this.distribution = success.distribution
        this.throng = success.throng
        this.haploid = success.haploid
      })
    }
  },
  mounted () {
    if (this.parent === 'father') {
      this.name = '父系单倍型'
      this.paternal_haploid()
    } else if (this.parent === 'mother') {
      this.name = '母系单倍型'
      this.maternal_haploid()
    } else {
    }
  },
  components: {
    Search
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/scss/functions";
  img {
    display: block;
  }
  .detail {
    padding: pxToRem(20px);
    background: #fff;
    margin: pxToRem(20px) 0;

    .dot {
      display: inline-block;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: #E5C6F2;
    }

    .haplotypetitle {
      margin-left: pxToRem(20px);
    }
    p {
      width: 90%;
      margin: pxToRem(20px) auto;
      color: #686868;
      font-size: 12px;
    }
  }
  .tips {
    padding: pxToRem(40px);
    line-height: pxToRem(50px);
    p {
      text-indent: 2em;
    }
  }
  .treeImg {
    width: 100%;
    margin: pxToRem(20px) 0;
  }
  .treeTitle {
    display: block;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/views/source/haplotype.vue